import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import ApiURL from '../Api/Api';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { SidebarContext } from './SidebarContext';

const TransactionPhotoSettings = () => {
  const userId = localStorage.getItem('id');
  const role = localStorage.getItem('role');
  const [required, setRequired] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const { isSidebarOpen } = useContext(SidebarContext);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await fetch(`${ApiURL}/getTransactionPhotoSettings.php?user_id=${userId}`);
        const data = await response.json();
        if (data.status === 'success') {
          setRequired(Boolean(data.transaction_photo_required));
        } else {
          throw new Error(data.message || 'Failed to load photo settings');
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [userId]);

  const save = async (nextValue) => {
    setSaving(true);
    try {
      const response = await fetch(`${ApiURL}/updateTransactionPhotoSettings.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          owner_id: Number(userId),
          transaction_photo_required: nextValue,
        }),
      });
      const data = await response.json();
      if (data.status !== 'success') {
        throw new Error(data.message || 'Failed to update setting');
      }
      setRequired(nextValue);
      toast.success('Transaction photo setting updated');
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSaving(false);
    }
  };

  if (role !== 'company_owner') {
    return (
      <div className="min-h-screen bg-slate-100 p-6 pt-20">
        <div className="rounded-xl border border-rose-200 bg-rose-50 p-4 text-rose-700">Only company owner can manage this setting.</div>
      </div>
    );
  }

  return (
    <div className="app-shell min-h-screen pt-16">
      <Navbar />
      <Sidebar />
      <main className={`min-w-0 p-4 sm:p-6 transition-all duration-300 ${isSidebarOpen ? 'lg:ml-72' : ''}`}>
      <div className="mx-auto max-w-4xl page-surface p-6">
        <p className="text-xs font-bold uppercase tracking-widest text-brand-600">Company Owner Setting</p>
        <h1 className="mt-2 text-2xl font-bold text-slate-900">Transaction Photo Requirement</h1>
        <p className="mt-2 text-sm text-slate-500">
          Control whether every transaction and request form must include a proof image. Uploaded images are compressed to 100 KB before saving.
        </p>

        <div className="mt-6 rounded-xl border border-slate-200 bg-slate-50 p-4">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h2 className="text-sm font-bold text-slate-900">Require proof image</h2>
              <p className="mt-1 text-xs text-slate-500">
                {required ? 'Photo is mandatory in transaction forms.' : 'Photo is optional in transaction forms.'}
              </p>
            </div>
            <button
              type="button"
              disabled={loading || saving}
              onClick={() => save(!required)}
              className={`relative inline-flex h-8 w-16 items-center rounded-full transition ${
                required ? 'bg-brand-600' : 'bg-slate-300'
              } disabled:opacity-60`}
            >
              <span
                className={`inline-block h-6 w-6 transform rounded-full bg-white shadow transition ${
                  required ? 'translate-x-9' : 'translate-x-1'
                }`}
              />
            </button>
          </div>
        </div>
      </div>
      </main>
    </div>
  );
};

export default TransactionPhotoSettings;
